import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Avatar, IconButton, Box } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useStyles } from '../styles';
import { Project } from '../types';
import { STYLE } from 'constants/style';

interface ProjectCardProps {
  project: Project;
  onMenuClick: (event: React.MouseEvent<HTMLElement>, project: Project) => void;
  onViewMissingRequirements?: (project: Project) => void;
}

export const ProjectCard: React.FC<ProjectCardProps> = ({ project, onMenuClick, onViewMissingRequirements }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const projectStatus = useMemo(() => {
    if (project?.projectStatus === 3) {
      return {
        label: t('projectList.status.past'),
        color: STYLE.COLOR.WHITE,
        backgroundColor: STYLE.COLOR.ICONS3,
      };
    } else if (project?.workerProjectStatus === 1) {
      return {
        label: t('projectList.status.current'),
        color: STYLE.COLOR.SUCCESS,
        backgroundColor: STYLE.COLOR.SUCCESS_BACKGROUND,
      };
    }
    return {
      label: t('projectList.status.pending'),
      color: STYLE.COLOR.WARNING,
      backgroundColor: STYLE.COLOR.PENDING,
    };
  }, [project]);

  const projectId = project?.project?.id;

  return (
    <Card className={classes.projectCard} data-testid={`project-card-${projectId}`}>
      {/* <div className={classes.statusContainer}>
        <p
          className={classes.projectStatusText}
          style={{ color: projectStatus?.color, backgroundColor: projectStatus?.backgroundColor }}
        >
          {projectStatus?.label || '-'}
        </p>
      </div> */}
      <Box className={classes.projectInfo}>
        <Box className={classes.avatarContainer}>
          <Avatar className={classes.projectAvatar} src={project?.project?.logoUrl || ''}>
            {project?.project?.name?.charAt(0)?.toUpperCase() || '-'}
          </Avatar>
          <p className={classes.projectName} data-testid={`project-card-name-${projectId}`}>
            {project?.project?.name || '-'}
          </p>
        </Box>
        <IconButton
          size="small"
          data-testid={`project-menu-button-${projectId}`}
          onClick={e => onMenuClick(e, project)}
          className={classes.menuButton}
        >
          <MoreVertIcon />
        </IconButton>
      </Box>
      <div className={classes.companiesContainer}>
        <p className={classes.companiesText} data-testid={`project-card-companies-${projectId}`}>
          {project?.companies?.map?.(company => company?.company?.name)?.join?.(', ') || '-'}
        </p>
        {project?.workerProjectStatus === 1 && onViewMissingRequirements && (
          <span
            className={classes.viewMissingRequirementsLink}
            data-testid={`project-view-missing-requirements-${projectId}`}
            onClick={() => onViewMissingRequirements(project)}
          >
            {t('projectList.viewMissingRequirements')}
          </span>
        )}
      </div>
    </Card>
  );
};
